import { objectToFormData } from '@services/io/file';
import { api } from '..';

export const uploadFile = async (params: any) => {
  const formData = objectToFormData(params);

  return api.post('/transactions/import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const listFileHistory = async (params: any) => {
  return api.get('/transactions/files', { params });
};

export const remove = async (id: string) => {
  return api.delete(`/transactions/files/${id}`);
};
